/**
 * Страница врача
 *
 * @param {Object} params
 * @param {String} params.blockButtonSpoilerVideo - область с кнопкой скрытия и раскрытия дополнительных видео
 * @param {String} params.buttonSpoilerVideo - кнопка скрытия и раскрытия дополнительных видео
 * @param {Number} params.anotherVideoCount - количество дополнительных видео
 */
$.fn.doctorItem = function (params) {

    const $self = $(this);
    const $blockButtonSpoilerVideo = $self.find(params.blockButtonSpoilerVideo);
    const buttonSpoilerVideo = params.buttonSpoilerVideo;
    const anotherVideoCount = $self.find($(buttonSpoilerVideo)).attr(params.anotherVideoCount);

    let viewportWindow = $(window).width();
    let videoCount = anotherVideoCount;

    if (viewportWindow >= 1280) {
        videoCount = videoCount - 2;
    }

    if (viewportWindow < 1280 && viewportWindow >= 768) {
        videoCount = videoCount - 1;
    }

    if (viewportWindow < 768) {
        videoCount = videoCount - 0;
    }

    if (videoCount > 0) {
        $blockButtonSpoilerVideo.show();
    } else {
        $blockButtonSpoilerVideo.hide();
    }

    let open = true;

    /**
     * Cкрытие и раскрытие дополнительных видео
     */
    $self.on('click', buttonSpoilerVideo, function () {

        open = !open;
        if (open) {
            $(this).find('.open').show();
            $(this).find('.close').hide();
        } else {
            $(this).find('.open').hide();
            $(this).find('.close').show();
        }
    });

    return this;
};

// инициализация
const init = function () {

    $('#doctor-item-module').doctorItem({
        buttonSpoilerVideo: '[data-button-spoiler-video="true"]',
        blockButtonSpoilerVideo: $('#button-spoiler-video'),
        anotherVideoCount: 'data-another-video-count',
    });
};

if ($('#doctor-item-module').length > 0) {
    init();
}
